<template>
  <div class="platform" :class="{ active: isActive }">
    <h3 class="platform__title" data-test-id="web-platform-title">{{ $t('platformWeb.title') }}</h3>
    <div class="platform__content" v-show="isActive">
      <div class="platform__description">{{ $t('platformWeb.description') }}</div>
      <a :href="openAppUrl" target="_blank" class="platform__btn btn btn--primary" data-test-id="web-platform-link-to-open">
        <span class="btn-text">{{ $t('platformWeb.openApp') }}</span>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { makeOpenAppUrl } from '@/apps/app-url'
import { IApp } from '@/interfaces'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'PlatformWeb',
  props: {
    appData: {
      type: Object as PropType<IApp>,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    openAppUrl (): string | undefined {
      return makeOpenAppUrl(this.appData)
    }
  }
})
</script>

<style lang="scss" scoped>
.platform__title::before {
  background-image: url('~@/assets/platforms/external-link.svg');

  @media (prefers-color-scheme: dark) {
    background-image: url('~@/assets/platforms/external-link-dark.svg');
  }
}
</style>
